import { render, staticRenderFns } from "./convention.vue?vue&type=template&id=72c83238&scoped=true"
import script from "./convention.vue?vue&type=script&lang=js"
export * from "./convention.vue?vue&type=script&lang=js"
import style0 from "./convention.vue?vue&type=style&index=0&id=72c83238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c83238",
  null
  
)

export default component.exports